<template>
  <header class="sticky-top">
    <div class="app-header">
      <div class="container-fluid">
        <div class="navbar navbar-expand-lg">
          <a href="/" class="navbar-brand">
            <NuxtImg provider="kontentAiProvider" :src="logo" alt="GNPC Logo" class="logo" />
          </a>
          <button class="navbar-toggler collapsed" type="button" data-bs-toggle="collapse"
            data-bs-target="#navbarToggler" aria-controls="navbarToggler" aria-expanded="false"
            aria-label="Toggle navigation">
            <img src="./assets/img/icon-hamburger.svg" class="open" />
            <img src="./assets/img/icon-close.svg" class="close" />
          </button>
          <div class="collapse navbar-collapse" id="navbarToggler">
            <ul class="navbar-nav">
              <template v-for="(item, idx) in navigationItems" :key="idx">
                <li class="nav-item" v-if="!item.subItems || item.subItems.length == 0">
                  <NuxtLink :to="item.url" class="nav-link" :class="{ active: isActivePage(item.url) }">
                    {{ item.title }}</NuxtLink>
                </li>

                <li class="nav-item dropdown" v-else>
                  <div class="d-flex align-items-start justify-content-start">
                    <NuxtLink class="nav-link me-2" :to="item.url" :class="{ active: isActivePage(item.url) }">{{ item.title }}</NuxtLink>

                    <NuxtLink class="nav-link dropdown-toggle align-self-start pt-2" :class="{ show: props.expandMenu }" role="button"
                      data-bs-toggle="dropdown" aria-expanded="false">
                      <img class="icon" src="./assets/img/icon-chevron-down.svg" />
                    </NuxtLink>
                    <ul class="dropdown-menu" :class="{ show: props.expandMenu }">
                      <li v-for="(subItem, idx) in item.subItems">
                        <NuxtLink class="dropdown-item" :to="subItem.url">{{ subItem.title }}</NuxtLink>
                      </li>
                    </ul>
                  </div>

                </li>
              </template>

            </ul>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script setup lang="ts">
import type { NavigationItem } from '~/types/NavigationItem'

const props = withDefaults(
  defineProps<{ expandMenu?: boolean }>(),
  { expandMenu: false }
)

const logo = ref('')
const navigationItems = ref<NavigationItem[]>([])
const siteStore = useSiteStore()
if (siteStore?.site?.elements?.websiteLogo?.value?.length ?? 0 > 0) {
  logo.value = siteStore?.site?.elements?.websiteLogo?.value?.[0]?.url ?? ''
}
navigationItems.value = siteStore.getHeaderNavigationItems()

const route = useRoute()

if (process.client) {
  const { $bsCollapse } = useNuxtApp()
  const bsCollapse = new $bsCollapse('#navbarToggler', {
    toggle: false
  })

  watch(
    () => route.fullPath,
    () => {
      nextTick(() => {
        bsCollapse.hide()
      })
    }
  )
}

function isActivePage(linkUrl: string): boolean {
  if (route.path.includes('/cohorts/')) {
    return linkUrl.includes('cohort')
  }
  return linkUrl === route.path
}
</script>

<style lang="scss" scoped></style>
